import { render, staticRenderFns } from "./basicHistory.vue?vue&type=template&id=6d95d93e"
import script from "./basicHistory.vue?vue&type=script&lang=js"
export * from "./basicHistory.vue?vue&type=script&lang=js"
import style0 from "./basicHistory.vue?vue&type=style&index=0&id=6d95d93e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports